<script setup lang="ts">
import type { AdminBatchResponse } from "mws-fabricks-ts-sdk";
import { ref } from "vue";

import BaseButton from "@/common/components/BaseButton.vue";
import PageWrapper from "@/common/components/PageWrapper.vue";
import RouterLinkVue from "@/common/components/RouterLinkVue.vue";
import PaginatedTable from "@/common/components/table/PaginatedTable.vue";
import type { TableColumn } from "@/common/components/table/types";
import { useListTrackableProductBatchesQuery } from "@/fabricks/batches/api/queries";
import BatchCreateModal from "@/fabricks/batches/components/BatchCreateModal.vue";
import FabricksPartnerAutocomplete from "@/fabricks/partners/components/FabricksPartnerAutocomplete.vue";

definePage({
  meta: {
    auth: ["FabricksAdmin.Access"],
  },
});

const createBatchModalOpen = ref(false);

const columns: TableColumn<AdminBatchResponse>[] = [
  {
    key: "description",
    label: "Description",
    type: "link",
    pathConstructor: (item) =>
      `/fabricks/batches/${item.id}/trackable-products`,
  },
  {
    key: "partnerName",
    label: "Partner",
    type: "slot",
  },
  {
    key: "dateCreated",
    label: "Date Created",
    type: "date",
  },
  {
    key: "dateModified",
    label: "Date Modified",
    type: "date",
  },
];

const breadcrumbs = [
  {
    label: "Batches",
    to: "#",
  },
];
</script>

<template>
  <PageWrapper
    title="Fabricks Batches"
    :breadcrumb-links="breadcrumbs"
  >
    <template #actions>
      <BaseButton
        variant="primary"
        label="Create"
        @click="createBatchModalOpen = true"
      />
    </template>
    <PaginatedTable
      :columns="columns"
      :is-searchable="true"
      :collection-query-fn="useListTrackableProductBatchesQuery"
      :collection-options="{
        initialFilters: { partnerId: undefined },
      }"
    >
      <template #filters="{ filters }">
        <FabricksPartnerAutocomplete
          v-model="filters.partnerId"
          placeholder="Partner"
          label=""
          name="partnerId"
          outer-class="!max-w-[20rem]"
          data-test="partner-autocomplete"
        />
      </template>

      <template #partnerName="{ item }">
        <RouterLinkVue
          v-if="item.partner"
          :to="`/partners/${item.partner.id}/details`"
        >
          {{ item.partner.name }}
        </RouterLinkVue>
      </template>
    </PaginatedTable>

    <BatchCreateModal v-model:is-open="createBatchModalOpen" />
  </PageWrapper>
</template>
